import type {
  ActivityType,
  MedicationActivity,
  DeepPartial,
} from "@tandemdiabetes/sugarmate-api-react-client"
import {
  useCallback,
  useEffect,
  useRef,
} from "react"
import type { DeepReadonlyObject } from "rxdb"

import type {
  AccountMedication,
  EditableSubEntry,
} from "src/types"

export function useOnCurrentAccountMedicationDeleted(
  activity: DeepPartial<MedicationActivity> | undefined,
  updateActivity: (a: DeepPartial<MedicationActivity>) => void,
  currentAccountMedication: DeepReadonlyObject<AccountMedication> | undefined,
  currentSubEntry: EditableSubEntry<ActivityType.Medication>,
) {
  const previousAccountMedicationRef = useRef<AccountMedication | undefined>(currentAccountMedication)

  // reset the activity if it is a new activity and its account medication is removed
  const resetIfUnsaved = useCallback(
    () => {
      if (!currentSubEntry._id) {
        updateActivity({
          medication: undefined,
        })
      }
    },
    [
      updateActivity,
      currentSubEntry._id,
    ],
  )

  useEffect(
    () => {
      if (
        !currentAccountMedication &&
        !!previousAccountMedicationRef.current &&
        previousAccountMedicationRef.current.id === `${activity?.medication?.account_med_id}`
      ) {
        resetIfUnsaved()
      }

      previousAccountMedicationRef.current = currentAccountMedication
    },
    [
      activity,
      resetIfUnsaved,
      currentAccountMedication,
      previousAccountMedicationRef,
    ],
  )
}
